import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateLocationGeneralDetailsRequest extends BaseUpdateRequest {
    legacyId: string;
    registeredName: string;
    emailAddress: string;
    phoneNumber: string;
    taxNumber: string;
    registrationNumber: string;
    rateCardId: string;
    locationTypeId: string;
}